import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";

import ExportJSON from "components/Dataset/ExportJSON";

class ExportJSONContainer extends React.PureComponent {
  render() {
    return <ExportJSON {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchDatasetJSON: () => dispatch(homeReducer.fetchDatasetJSON(ownProps.id))
  };
};
const mapStateToProps = (state, ownProps) => {
  return {
    datasetName: ownProps.id ? homeReducer.getDatasetLabel(state, ownProps.id) : undefined,
    datasetUrl: ownProps.id ? homeReducer.getDatasetUrl(state, ownProps.id) : undefined,
    isLinkedDataset: homeReducer.getIsLinkedDataset(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ExportJSONContainer);
